import { englishFormattedEuroCurrency } from '@getpopsure/public-utility';
import { QuestionnaireQuestions } from '@getpopsure/qnr-framework';
import dayjs from 'dayjs';
import { QuestionReviewValue } from 'models/review';
import { QuestionReviewValueType } from 'SignupQuestionnaire/components/Review/Review';

export const prepareReviewValues = <
  Questionnaire extends QuestionnaireQuestions
>(
  answers: Partial<Questionnaire>,
  reviewValues: QuestionReviewValueType<Questionnaire>[]
) => {
  const reviews: QuestionReviewValue[] = [];
  for (const reviewValue of reviewValues) {
    switch (reviewValue.value?.type) {
      case 'String': {
        const map = reviewValue.value.valueMap;
        const value = String(answers[reviewValue.value.key] ?? '');
        reviews.push({
          ...reviewValue,
          value: map ? map[value] : value,
        });
        break;
      }
      case 'Strings': {
        const answer = answers[reviewValue.value.key];
        if (answer && typeof answer === 'object') {
          const value = reviewValue.value.keys.reduce((acc, key) => {
            return `${acc} ${(answer as Record<string, unknown>)[key]}`;
          }, '');
          reviews.push({
            ...reviewValue,
            value,
          });
        }
        break;
      }
      case 'Date': {
        const answer = answers[reviewValue.value.key];
        if (answer) {
          const value = dayjs(answer as string).format(
            reviewValue.value.format
          );
          reviews.push({
            ...reviewValue,
            value,
          });
        }
        break;
      }
      case 'Array': {
        const selectedAnswers = answers[reviewValue.value.key];
        const pick = reviewValue.value.pick ? reviewValue.value.pick[0] : false;
        const { valueMap: map, transform } = reviewValue.value;
        const value = ((selectedAnswers || []) as [])
          .reduce((acc, answer) => {
            return [
              ...acc,
              pick ? (answer as Record<string, never>)[pick] : answer,
            ];
          }, [])
          .map((v) => (transform ? transform(v) : v))
          .map((v) => (map ? map[v] : v))
          .join(', ');
        reviews.push({
          ...reviewValue,
          value,
        });
        break;
      }
      case 'Object': {
        const selectedAnswers = answers[reviewValue.value.key];
        if (
          selectedAnswers !== undefined &&
          selectedAnswers !== null &&
          typeof selectedAnswers === 'object'
        ) {
          const value = Object.entries(
            selectedAnswers as Record<string, unknown>
          )
            .reduce<string[]>((acc, [key, answer]) => {
              return [...acc, `${key}: ${answer}`];
            }, [])
            .join(' / ');
          reviews.push({
            ...reviewValue,
            value,
          });
        }
        break;
      }
      case 'Boolean': {
        const answer = answers[reviewValue.value.key];
        if (answer !== undefined) {
          const map = reviewValue.value.valueMap ?? {
            true: 'Yes',
            false: 'No',
          };
          const value = answer === true ? map.true : map.false;
          reviews.push({
            ...reviewValue,
            value,
          });
        }
        break;
      }

      case 'Currency': {
        const answer = answers[reviewValue.value.key];
        if (answer !== undefined) {
          const value = englishFormattedEuroCurrency(Number(answer), true);
          reviews.push({
            ...reviewValue,
            value,
          });
        }
        break;
      }

      case 'Upload': {
        const answer = answers[reviewValue.value.key];
        const value = ((answer || []) as []).map(({ name }) => name).join(', ');

        reviews.push({
          ...reviewValue,
          value,
        });

        break;
      }
    }
  }
  return reviews;
};
